const payments = [
  {
    id: 1,
    amount: '10,000',
    card: 'Visa末尾: 4242　有効期限: 1/2022',
    paid_date: '2020/09/07',
  },
  {
    id: 2,
    amount: '20,000',
    card: 'Visa末尾: 1234　有効期限: 2/2023',
    paid_date: '2020/09/08',
  },
  {
    id: 3,
    amount: '30,000',
    card: 'Master末尾: 5678　有効期限: 3/2024',
    paid_date: '2020/09/09',
  },
  {
    id: 4,
    amount: '40,000',
    card: 'Master末尾: 1111　有効期限: 4/2025',
    paid_date: '2020/010/10',
  },
]

export default payments
